import { useState, useEffect } from "react";
import getUrlParams from "helpers/get-url-params";

const useModal = (type) => {
	const [modal, setModal] = useState({});

	const openModal = (item, close = false) => {
		setModal((prevState) => ({
			...prevState,
			[item]: !close,
		}));
		const url = new URL(window.location);
		if (!url.searchParams.get(type)) {
			url.searchParams.set(type, item);
			window.history.pushState({}, "", url);
		}
	};

	const closeModal = (item) => {
		openModal(item, true);
		const url = new URL(window.location);
		url.searchParams.delete(type);
		window.history.pushState({}, "", url);
	};

	useEffect(() => {
		const param = getUrlParams(type);
		param && openModal(param);
	}, []);

	return [modal, openModal, closeModal];
};

export default useModal;
